export default __webpack_public_path__ + "static/media/coleta.444cd884.mp4";